import { setAssignmentDate } from '../../services/assignments';
import { setPhaseEndDate } from '../../services/phases';
import { notify } from '../../store/feedback';
import { fmtDate } from '../../utils/format';
import {
  getClientByBrick,
  getPhaseById,
  isPhaseEntry,
  isProjectEntry,
  phaseIdFromEntry,
  phaseInfoForBrique,
  projectIdFromEntry,
} from '../../utils/phases';
import { assignmentBeforePhaseError } from '../../utils/planning';
import { currentDeals, syncLineDates } from '../deals/lineDatesSync';

/* Affectations : ouverture en édition, redimensionnement sur la frise, prolongation de phase. */
export default function planningAssignmentsHandlers(deps, api) {
  const { openModal, appState, deals, setDeals, update } = deps;

  function openEditAssignment(affId, clickedDay = null) {
    const aff = appState.affectations.find((a) => a.id === affId);
    if (!aff) return;
    let clientId = '',
      briqueId = '',
      phaseId = '';
    if (isPhaseEntry(aff.briqueId)) {
      const res = getPhaseById(appState.clients, phaseIdFromEntry(aff.briqueId));
      clientId = res?.client.id || '';
      phaseId = res?.phase.id || '';
    } else if (isProjectEntry(aff.briqueId)) {
      clientId = projectIdFromEntry(aff.briqueId);
    } else {
      const res = getClientByBrick(appState.clients, aff.briqueId);
      clientId = res?.client.id || '';
      phaseId = res?.phase.id || '';
      briqueId = aff.briqueId;
    }
    const initForm = {
      devId: aff.devId,
      clientId,
      phaseId,
      briqueId,
      debut: aff.debut,
      fin: aff.fin,
      heuresParJour: String(aff.heuresParJour),
    };
    openModal('editAff', { affId: aff.id, clickedDay, initialForm: initForm }, { ...initForm });
  }

  async function saveAssignmentResize(affId, edge, newIso) {
    if (!newIso || !affId) return;
    const aff = appState.affectations.find((a) => a.id === affId);
    const dev = aff && appState.devs.find((d) => d.id === aff.devId);
    if (dev?.dateFinContrat && newIso > dev.dateFinContrat) {
      notify(
        `Impossible : le contrat de ${dev.nom} est terminé depuis le ${fmtDate(dev.dateFinContrat)}.`,
      );
      return;
    }
    const field = edge === 'left' ? 'debut' : 'fin';
    if (field === 'debut' && aff && !isProjectEntry(aff.briqueId)) {
      const startError = assignmentBeforePhaseError(
        phaseInfoForBrique(appState.clients, aff.briqueId)?.phase,
        newIso,
      );
      if (startError) return void notify(startError);
    }
    const { error } = await setAssignmentDate(affId, field, newIso);
    if (error) {
      notify('Erreur lors de la mise à jour : ' + error.message);
      return;
    }
    update((s) => ({
      ...s,
      affectations: s.affectations.map((a) => (a.id === affId ? { ...a, [field]: newIso } : a)),
    }));
  }

  // Étend la date de fin d'une phase en DB et dans le state.
  async function extendPhaseEnd(phase, client, newEnd) {
    await setPhaseEndDate(newEnd, phase);
    // Phase convertie : la nouvelle fin est reportée sur la ligne de l'affaire (dates pilotées
    // par le projet).
    const allDeals = await currentDeals(deals, api);
    await syncLineDates({ deals: allDeals, setDeals }, phase, phase.dateDebut, newEnd);
    update((s) => ({
      ...s,
      clients: s.clients.map((c) =>
        c.id !== client.id
          ? c
          : {
              ...c,
              phases: c.phases.map((ph) => (ph.id !== phase.id ? ph : { ...ph, dateFin: newEnd })),
            },
      ),
    }));
  }

  return { openEditAssignment, saveAssignmentResize, extendPhaseEnd };
}
